import { Component, OnInit } from '@angular/core';
import { VisitorManagementService } from '../visitor-management.service';

@Component({
  selector: 'app-induction-training-paper',
  templateUrl: './induction-training-paper.component.html',
  styleUrls: ['./induction-training-paper.component.css']
})
export class InductionTrainingPaperComponent implements OnInit {
  applicationNo: string = '';
  showQuestions: boolean = false;
  currentQuestionIndex: number = 0;
  showResults: boolean = false;
  isSubmitting: boolean = false;

  questions = [
    {
      id: 1,
      question: 'Name of Participant प्रतिभागी का नाम',
      type: 'text',
      answer: ''
    },
    {
      id: 2,
      question: 'Ticket No. / Employee No.',
      type: 'text',
      answer: ''
    },
    {
      id: 3,
      question: 'ऊँचाई पर काम करने के लिए क्या जरूरी नहीं है?',
      type: 'radio',
      options: ['सेफ्टी बेल्ट', 'हार्ड पास', 'ड्राइंग लाइन्स', 'गेट्स तक गार्मिट'],
      correctAnswer: 'सेफ्टी बेल्ट',
      answer: ''
    },
    {
      id: 4,
      question: 'क्रेनाईड स्पेस में काम करने के लिए ऑक्सीजन लिमिट कितना होना चाहिए?',
      type: 'radio',
      options: ['100%', '0%', '19.5% से 23.5% के बीच', 'कोई सीमा नहीं है'],
      correctAnswer: '100%',
      answer: ''
    },
    {
      id: 5,
      question: 'किसी मशीन में काम करने में पहले क्या सुनिश्चित करना आवश्यक है?',
      type: 'radio',
      options: ['आइसोलेशन', 'लॉक आउट टैग आउट', 'सेफ्टी वर्क परमिट', 'लोनी चीजें आवश्यक हैं'],
      correctAnswer: 'आइसोलेशन',
      answer: ''
    },
    {
      id: 6,
      question: 'बालकों में क्या मनना है?',
      type: 'radio',
      options: ['हाफ ग्रेट पहनकर काम करना', 'गार्ली पर्मेनेंट रूम वाले सेफ्टी बेल्ट का उपयोग करना', 'टेस्टर का उपयोग करना', 'लोनी चीजें मनना है'],
      correctAnswer: 'हाफ ग्रेट पहनकर काम करना',
      answer: ''
    },
    {
      id: 7,
      question: 'कौन सा सेफ्टी कार्डिनल रूल नहीं है?',
      type: 'radio',
      options: ['सेफ्टी पी पी ई का उपयोग करना', 'मानक कार्य प्रणाली (एस ओ पी / एस एस पी) का पालन करना', 'जबरद का सेवन न करना', 'प्लाट में मोबाइल फोन लेकर आना'],
      correctAnswer: 'सेफ्टी पी पी ई का उपयोग करना',
      answer: ''
    },
    {
      id: 8,
      question: 'कौन कौन सा सुरक्षा उपकरण प्लाट के अंदर आने के लिए आवश्यक है?',
      type: 'radio',
      options: ['हेलमेट, जूता, चश्मा', 'हेलमेट, जूता, चश्मा, रिप्लेसमेंट जैकेट', 'हेलमेट, सेफ्टी बेल्ट, चश्मा', 'रिप्लेसमेंट जैकेट, जूता, दस्ताना'],
      correctAnswer: 'हेलमेट, जूता, चश्मा',
      answer: ''
    },
    {
      id: 9,
      question: 'क्रेनाईड स्पेस में कौन से तत्व हो सकते हैं?',
      type: 'radio',
      options: ['ऑक्सीजन की कमी', 'अत्यधिक तापमान', 'मशीन का संचालन चालू होना', 'सभी हो सकते हैं'],
      correctAnswer: 'ऑक्सीजन की कमी',
      answer: ''
    },
    {
      id: 10,
      question: 'किसी वजन को उठाने समय उसके नीचे न होना चाहिए।',
      type: 'radio',
      options: ['सही', 'गलत'],
      correctAnswer: 'सही',
      answer: ''
    },
    {
      id: 11,
      question: 'बालकों में सुरक्षा नियम तोड़ जाने पर अनुशासनात्मक कार्रवाई की जा सकती है।',
      type: 'radio',
      options: ['सही', 'गलत'],
      correctAnswer: 'सही',
      answer: ''
    }
  ];

  constructor(private visitorService: VisitorManagementService) { }

  ngOnInit() {
  }

  submitApplicationNo() {
    if (this.applicationNo.trim()) {
      this.showQuestions = true;
    }
  }

  selectAnswer(answer: string) {
    this.questions[this.currentQuestionIndex].answer = answer;
  }

  nextQuestion() {
    if (this.currentQuestionIndex < this.questions.length - 1) {
      this.currentQuestionIndex++;
    }
  }

  previousQuestion() {
    if (this.currentQuestionIndex > 0) {
      this.currentQuestionIndex--;
    }
  }

  submitTest() {
    this.isSubmitting = true;
    const testPaperJSON = this.prepareTestPaperJSON();
    const payload = this.createPayload(testPaperJSON);

    this.visitorService.createVisitor(payload).subscribe(
      (response) => {
        this.isSubmitting = false;
        this.showResults = true;
        console.log('Test submitted successfully', response);
      },
      (error) => {
        this.isSubmitting = false;
        console.error('Error submitting test', error);
        alert('Failed to submit test. Please try again.');
      }
    );
  }

  prepareTestPaperJSON(): string {
    const testData = [];
    
    for (let i = 2; i < this.questions.length; i++) {
      const q = this.questions[i];
      if (q.type === 'radio') {
        const questionObj: any = {
          question: q.question
        };
        
        q.options.forEach((opt, idx) => {
          questionObj[String.fromCharCode(65 + idx)] = opt;
        });
        
        const answerIndex = q.options.indexOf(q.answer);
        questionObj.answer = answerIndex >= 0 ? String.fromCharCode(65 + answerIndex) : '';
        
        testData.push(questionObj);
      }
    }
    
    return JSON.stringify(testData).replace(/"/g, '\\"');
  }

  createPayload(testPaperJSON: string): any {
    const guid = '47DF4E41-7E65-40EF-930B-257B8F61E215';
    const score = this.getScorePercentage();
    
    return {
      [guid]: {
        ID: null,
        Page_Code: 424,
        Referance_Code: parseInt(this.applicationNo) || 123,
        TestPaperJSON: testPaperJSON,
        MarksPoint: score.toFixed(2),
        ResultStatusMIL_Code: 123,
        CreatedBy: 100,
        Modifiedby: 100,
        IsActive: 1,
        IsDeleted: 0
      }
    };
  }

  isAnswerCorrect(question: any): boolean {
    if (question.type === 'text') return true;
    return question.answer === question.correctAnswer;
  }

  goToQuestion(index: number) {
    this.currentQuestionIndex = index;
    this.showResults = false;
  }

  getProgress(): number {
    return Math.round(((this.currentQuestionIndex + 1) / this.questions.length) * 100);
  }

  getOptionLetter(index: number): string {
    return String.fromCharCode(65 + index);
  }

  getCorrectAnswers(): number {
    return this.questions.filter(q => this.isAnswerCorrect(q)).length;
  }

  getWrongAnswers(): number {
    return this.questions.filter(q => q.type === 'radio' && !this.isAnswerCorrect(q)).length;
  }

  getScorePercentage(): number {
    const radioQuestions = this.questions.filter(q => q.type === 'radio');
    const correctAnswers = radioQuestions.filter(q => this.isAnswerCorrect(q)).length;
    return Math.round((correctAnswers / radioQuestions.length) * 100);
  }
}
